<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplayWindProfile',
  routeInfo: {
    label: '风廓线雷达',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/09WindProfile/index.vue